import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAspectRatio219: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="aspect-ratio-21-9, wide, landscape"><path d="M0.75 6.75H23.25V17.25H0.75V6.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconAspectRatio219;
